import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, EASE } from "@/lib/motion";
import { scrollToId } from "@/lib/smoothScroll";

export default function ClosingCTA() {
  return (
    <section className="relative overflow-hidden border-y border-hairline bg-bg-surface/45 py-24 backdrop-blur-sm lg:py-32">
      <div className="pointer-events-none absolute inset-0 grid-texture opacity-40" />
      <div className="pointer-events-none absolute bottom-[-40%] left-1/2 h-[520px] w-[720px] -translate-x-1/2 rounded-full bg-signal/[0.08] blur-[130px]" />
      <div className="container-max band-pad relative text-center">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-display text-3xl font-semibold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Your ops team already knows where the drag is.
          </h2>
        </Reveal>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
          className="mt-10"
        >
          <button
            data-testid="closing-cta"
            onClick={() => scrollToId("contact")}
            className="group inline-flex items-center gap-2.5 rounded-full bg-signal px-8 py-4 font-sans text-base font-semibold text-bg-primary transition-transform duration-200 hover:scale-[1.03] active:scale-95"
          >
            Book a workflow audit
            <ArrowRight
              size={18}
              className="transition-transform duration-200 group-hover:translate-x-1"
            />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
